import gql from "graphql-tag";

// eslint-disable-next-line no-restricted-imports -- TODO(FEI-7051): switch to useGql
import type {ApolloGqlClient} from "@khan/data-gql-apollo";
import {gqlOp, type GqlOperation} from "@khan/data-gql-core";
import {setPromptVariable} from "@khan/guide-core-helpers";

// eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
import type {AITeacherTools_VideoDetailsType} from "./__graphql-types__/index.ts";
import {setSharedDetails, unsetSharedDetails} from "./shared-details.ts";

export const VIDEO_DETAILS_QUERY: GqlOperation<
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_VideoDetailsType["response"],
    // eslint-disable-next-line camelcase -- Generated by GraphQL Codegen
    AITeacherTools_VideoDetailsType["variables"]
> = gqlOp(gql`
    query AITeacherTools_VideoDetails($videoId: String) {
        videoById(contentId: $videoId) {
            id
            translatedTitle
            defaultUrlPath
            parentTopic {
                id
                domainSlug
                allLearnableContent(includeUnlisted: false) {
                    id
                    translatedTitle
                    defaultUrlPath
                }
            }
            subtitles {
                text
            }
        }
    }
`);

export async function loadVideoDetails(
    gqlClient: ApolloGqlClient,
    videoId: string,
) {
    const response = await gqlClient.query(VIDEO_DETAILS_QUERY, {
        variables: {videoId},
        fetchPolicy: "cache-first",
    });

    const video = response.data?.videoById;
    if (!video) {
        return;
    }

    const domain = video.parentTopic?.domainSlug ?? "";
    if (domain) {
        setPromptVariable("domain", domain);
    }

    setPromptVariable("contentTitle", video.translatedTitle);

    const context = (video.subtitles || [])
        .map((entry) => entry?.text)
        .join(" ");

    // For historical reasons, we set the vaguely named 'context' variable,
    // but we also set a more descriptively-named variable:
    setPromptVariable("context", context);
    setPromptVariable("videoTranscript", context);

    setSharedDetails(video);
}

export function unloadVideoDetails() {
    ["contentTitle", "context", "domain", "videoTranscript"].forEach(
        (variable) => {
            setPromptVariable(variable, null);
        },
    );
    unsetSharedDetails();
}
